import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (typeof error === 'object' && error !== null) {
          const status =
            (error as { status?: number; status_code?: number }).status ??
            (error as { status?: number; status_code?: number }).status_code;
          if (status === 401 || status === 403 || status === 404) {
            return false;
          }
        }
        return failureCount < 2;
      },
      staleTime: 15000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
